export default __webpack_public_path__ + "static/media/1555.82bd35b7.png";